import { Select } from 'antd';
import { useEffect, useState } from 'react';
import { rangeInclusive } from '../../Roster/lib/util';

const { Option } = Select;

/**
 * Given two numbers, renders a select input with all the numbers in between.
 *
 * Created for durations, and so also has a label following the input for hours.
 */
export const InputDuration: React.FC<{
  readonly from: number;
  readonly to: number;
  readonly value?: number;
  readonly onChange?: (value: number) => void;
}> = ({ from, to, value, onChange }) => {
  const [options, setOptions] = useState<readonly number[]>([]);

  useEffect(() => {
    setOptions(rangeInclusive(from, to));
  }, [from, to]);

  return (
    <div style={{ display: 'flex' }}>
      <Select
        // role must be explicitly set here for the provision of valid aria attributes
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-expect-error
        role={'list'}
        aria-label={'duration'}
        aria-busy="true"
        aria-autocomplete={null}
        aria-activedescendant={null}
        aria-owns={null}
        aria-controls={null}
        className={'input-duration-select'}
        value={value}
        onChange={onChange}
        style={{ height: 'auto', maxWidth: 200 }}
      >
        {options.map((hour) => (
          <Option key={hour} value={hour} label={hour}>
            {hour}
          </Option>
        ))}
      </Select>
      <div
        style={{
          paddingLeft: 10,
          paddingRight: 10,
          backgroundColor: '#ededed',
          border: '1px solid lightgrey',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        hours
      </div>
    </div>
  );
};
